// extracted by mini-css-extract-plugin
module.exports = {"body":"User_body__3TApN","container":"User_container__1FVvE","iframe":"User_iframe__2rsJe"};